<svg width="350" height="90" [attr.x]="xBase" [attr.y]="y">
  <!-- color: $id37-medium-grey: $id37-grey-4 -->
  <circle [attr.cx]="50" [attr.cy]="50" r="21" fill="#5D6E77"/>
  <circle [attr.cx]="50" [attr.cy]="50" r="19" fill="white"/>
  <text x="50" y="50" class="distance-score">{{this.distance}}</text>
  <text x="95" y="50" class="motive-description">{{this.motive}}  </text>

</svg>
